import {useState} from 'react';

import {ReactComponent as FilterIcon} from '~/assets/icons/filter.svg';
import {ReactComponent as Close} from '~/assets/icons/close.svg';

import {useIsMobile} from '~/hooks/useIsMobile';
import {useParamHelper} from '~/hooks/useParamHelper';

/**
 * Client component to allow for conditional toggling of filters or other such items
 * that live in a left-hand drawer, operating via URL parameters for a collection or product search.
 * Although this currently only involves Searchspring filtering as of 7/6/23,
 * most of the ideas here are fairly generic and extensible should some other sort of
 * filtering API also enter the mix.
 * In addition, this UI/UX pattern is for now mobile-only, also 7/6/23
 */
export function ProductFilter({children}) {
  const {hasNonManualParams} = useParamHelper();
  // Show drawer on page load/reload if there are filters applied, essentially:
  const [filterIsVisible, setFilterIsVisible] = useState(hasNonManualParams);
  const isMobile = useIsMobile();

  if (!isMobile) return null;

  const toggleFilterVisibility = () => {
    setFilterIsVisible((prev) => !prev);
  };

  const trigger = (
    <button
      className="product-filter__trigger"
      onClick={toggleFilterVisibility}
    >
      <FilterIcon />
    </button>
  );

  const content = (
    <div
      className={'product-filter__content ' + (filterIsVisible ? 'active' : '')}
    >
      <button
        className="product-filter__close"
        onClick={toggleFilterVisibility}
      >
        <Close />
      </button>
      {children}
    </div>
  );

  return (
    <>
      {!filterIsVisible ?? trigger}
      {content}
    </>
  );
}
